<div class="card">
  <div>
    @for (summary of summaryList; track summary; let isLast = $last) {
      <div [ngClass]="{ 'pad-horizontal-20': true, highlight: summary.highlight }">
        <div class="row pad-vertical-20">
          @if (summary.highlight) {
            <div class="icon-innovative"></div>
          }
          <div class="column six text-bold">{{ summary.option }}</div>
          <div class="column six text-bold text-right">
            <p>{{ summary.value }}</p>
            @for (coverageHelp of summary.coverageHelpTextList; track coverageHelp) {
              <p class="caption pad-top-10">
                {{ coverageHelp }}
              </p>
            }
          </div>
        </div>
        @if (!isLast) {
          <hr class="margin-0" />
        }
      </div>
    }
  </div>
</div>
